module.exports = __webpack_public_path__ + "img/synopsis.e0781bae.jpg";